import { useTranslation } from 'react-i18next'
import plusButton from '../../../assets/images/buttons/plus-button.svg'
import arrowDownOnPlaceSvg from '../../../assets/images/icons/arrow-down-on-place.svg'
import { Icon } from '../../atoms'
import {
  avatarWrapper,
  iconStyle,
  infoBlock,
  name,
  playerContainer,
} from './index.css'

export const PlayerPlug = (props: {
  mode: 'invite' | 'sit'
  onClick: () => void
}) => {
  const { t } = useTranslation()
  return (
    <div
      className={playerContainer}
      onClick={props.onClick}
    >
      <div className={avatarWrapper}>
        <Icon
          src={props.mode === 'invite' ? plusButton : arrowDownOnPlaceSvg}
          analytic={{
            name: 'player_plug',
            params: {
              action: props.mode,
            },
          }}
          className={iconStyle}
        />
      </div>
      <div className={infoBlock}>
        <span className={name}>
          {props.mode === 'invite'
            ? t('table.label.inviteFriend')
            : t('table.label.sitHere')}
        </span>
      </div>
    </div>
  )
}
